import { inject, Injectable, signal } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs/operators';
import { ApplicationConfigurationService } from '../../core/services/app-config.service';
import { EzTextService } from "@template-ui/services/ez-text.service";

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  private pageTitleSubject = new BehaviorSubject<string>('');
  pageTitle$ = this.pageTitleSubject.asObservable();
  config = inject(ApplicationConfigurationService);
  envName!: string | undefined;
  tabPrefix!: string | undefined;

  constructor(
    private titleService: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    this.envName = this.config.appConfig?.pipeline.EnvironmentName;
  }

  templateService = inject(EzTextService);

  init() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        mergeMap((route) => route.data),
      )
      .subscribe((data) => {
        if (data['tabTitle']) {
          if (this.envName && this.envName.toLowerCase() !== 'prod') {

            let tabTitle = "";

            switch (this.envName.toLowerCase()) {
              case "localhost":
                tabTitle = `${data['tabTitle']}`;
                break;
              case "integration":
                tabTitle = `${data['tabTitle']}`;
                break;
              case "staging":
                tabTitle = `${data['tabTitle']}`;
                break;
              case "prodcopy":
                tabTitle = `${data['tabTitle']}`;
                break;
              default:
                tabTitle = `${data['tabTitle']}`
                break;
            }

            const resolvedTitle =  this.templateService.resolveTemplate(tabTitle, this.activatedRoute.snapshot.children[0].params);
            this.titleService.setTitle(resolvedTitle);

          } else {
            this.titleService.setTitle(data['tabTitle']);
          }

        }
        if (data['pageTitle']) {
          this.pageTitleSubject.next(data['pageTitle']);
        }
      });
  }
}
